import { User } from './user';
import { PurchaseOrder } from './purchaseOrder';

export enum TicketPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export enum TicketStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  CLOSED = 'closed'
}

export interface TicketNote {
  id: number;
  content: string;
  createdAt: string;
  createdBy: User;
  ticketId: number;
}

export enum TicketActivityAction {
  CREATED = 'CREATED',
  EDITED = 'EDITED',
  STATUS_CHANGE = 'STATUS_CHANGE',
  PO_LINK = 'PO_LINK',
  PO_UNLINK = 'PO_UNLINK',
  NOTE_ADDED = 'NOTE_ADDED',
  ATTACHMENT_ADDED = 'ATTACHMENT_ADDED',
  ATTACHMENT_REMOVED = 'ATTACHMENT_REMOVED',
}

export interface TicketActivityLog {
  id: number;
  timestamp: string;
  action: TicketActivityAction;
  details: string;
  user: User;
}

export interface CreateTicketDto {
  title: string;
  description: string;
  priority: TicketPriority;
  assignedToId?: number;
  purchaseOrderId?: number;
}

export interface UpdateTicketDto {
  title?: string;
  description?: string;
  priority?: TicketPriority;
  assignedToId?: number;
  purchaseOrderId?: number;
}

export interface CreateTicketNoteDto {
  content: string;
}

export interface Ticket {
  id: number;
  title: string;
  description: string;
  priority: TicketPriority;
  status: TicketStatus;
  createdBy: User;
  assignedTo?: User;
  notes: TicketNote[];
  activityLogs: TicketActivityLog[];
  purchaseOrder?: PurchaseOrder;
  purchaseOrderId?: number;
  createdAt: string;
  updatedAt: string;
  attachments?: string[];
}
